import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Layers, Tag, Menu, Plus } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useAuth } from '@/context/AuthContext';

interface MobileBottomNavProps {
  onOpenRecordActivity: () => void;
  onOpenMoreDrawer: () => void;
}

export const MobileBottomNav: React.FC<MobileBottomNavProps> = ({
  onOpenRecordActivity,
  onOpenMoreDrawer,
}) => {
  const { isOperations } = useAuth();

  return (
    <nav aria-label="Mobile Navigation" className="lg:hidden fixed bottom-0 left-0 right-0 h-16 bg-white border-t border-slate-200 z-40 px-2 flex items-center justify-around shadow-lg">
      {/* 1. Home */}
      <NavLink
        to="/"
        end
        className={({ isActive }) =>
          cn(
            'flex flex-col items-center justify-center flex-1 py-1 text-[11px] font-medium transition-colors touch-manipulation',
            isActive ? 'text-emerald-700 font-bold' : 'text-slate-500 hover:text-slate-900'
          )
        }
      >
        <Home className="w-5 h-5 mb-0.5" />
        <span>Home</span>
      </NavLink>

      {/* 2. Cycles */}
      <NavLink
        to="/cycles"
        className={({ isActive }) =>
          cn(
            'flex flex-col items-center justify-center flex-1 py-1 text-[11px] font-medium transition-colors touch-manipulation',
            isActive ? 'text-emerald-700 font-bold' : 'text-slate-500 hover:text-slate-900'
          )
        }
      >
        <Layers className="w-5 h-5 mb-0.5" />
        <span>Cycles</span>
      </NavLink>

      {/* 3. Center Floating Action Button (+) Record Activity */}
      {isOperations ? (
        <div className="flex-1 flex justify-center -mt-5">
          <button
            onClick={onOpenRecordActivity}
            className="w-13 h-13 rounded-full bg-emerald-700 text-white flex flex-col items-center justify-center shadow-lg hover:bg-emerald-600 active:scale-95 transition-transform border-4 border-white touch-manipulation"
            aria-label="Record Farm Activity"
          >
            <Plus className="w-6 h-6" />
          </button>
        </div>
      ) : (
        <div className="flex-1" />
      )}

      {/* 4. Sales */}
      <NavLink
        to="/sales"
        className={({ isActive }) =>
          cn(
            'flex flex-col items-center justify-center flex-1 py-1 text-[11px] font-medium transition-colors touch-manipulation',
            isActive ? 'text-emerald-700 font-bold' : 'text-slate-500 hover:text-slate-900'
          )
        }
      >
        <Tag className="w-5 h-5 mb-0.5" />
        <span>Sales</span>
      </NavLink>

      {/* 5. More Drawer */}
      <button
        onClick={onOpenMoreDrawer}
        className="flex flex-col items-center justify-center flex-1 py-1 text-[11px] font-medium text-slate-500 hover:text-slate-900 transition-colors touch-manipulation"
      >
        <Menu className="w-5 h-5 mb-0.5" />
        <span>More</span>
      </button>
    </nav>
  );
};
